// import './_dialog';
//
// $(document).ready(function () {
//     if (!!$('#pref').data('oldData')) {
//         getOldPrefAndCities();
//     }
//
//     if (!!$('#postCode').val()) {
//         getPrefAndCities();
//     }
//
//     $('#searchCityArea').on('click', function () {
//         getPrefAndCities();
//     });
//
//     $('#pref').on('change', function () {
//         var pref = $(this).val();
//
//         axios.post('/api/cities', {
//             lang: $('html').attr('lang'),
//             pref: pref,
//         }).then(function (response) {
//             var cities = response.data.data;
//
//             $('#city').find('option').remove();
//
//             for (var index in cities) {
//                 var city = cities[index];
//
//                 var option = '<option value="' + city.id + '">';
//                 option += city.current_name;
//                 option += '</option>';
//
//                 $('#city').append(option);
//             }
//
//             $('#postCode').val('');
//
//             $('#address').val('');
//         });
//     });
//
//     $('#myForm').find('input[type="submit"]')
//         .on('click', function () {
//             $(this).prop('disabled', true);
//
//             $('#myForm').submit();
//         });
// });
//
// function getPrefAndCities() {
//     axios.post('/api/city-areas', {
//         lang: $('html').attr('lang'),
//         relation: 'city.pref',
//         post_code: $('#postCode').val()
//     }).then(function (response) {
//         var cityArea = response.data.data[0];
//
//         axios.post('/api/prefs', {
//             lang: $('html').attr('lang'),
//             relation: 'cities',
//             area_id: cityArea.city.pref.area_id,
//         }).then(function (response) {
//             var prefs = response.data.data;
//
//             $('#pref').find('option').remove();
//
//             $('#city').find('option').remove();
//
//             for (var index in prefs) {
//                 var pref = prefs[index];
//                 var prefOption = '';
//                 var cities = [];
//
//                 if (pref.id === cityArea.city.pref_id) {
//                     prefOption += '<option value="' + pref.id + '" selected>';
//
//                     cities = pref.cities;
//                 } else {
//                     prefOption += '<option value="' + pref.id + '">';
//                 }
//
//                 prefOption += pref.current_name;
//                 prefOption += '</option>';
//
//                 $('#pref').append(prefOption);
//
//                 for (var index in cities) {
//                     var city = cities[index];
//                     var cityOption = '';
//
//                     if (city.id === cityArea.city_id) {
//                         cityOption += '<option value="' + city.id + '" selected>';
//                     } else {
//                         cityOption += '<option value="' + city.id + '">';
//                     }
//
//                     cityOption += city.current_name;
//                     cityOption += '</option>';
//
//                     $('#city').append(cityOption);
//                 }
//             }
//
//             if (!$('#address').data('oldData')) {
//                 $('#address').val(cityArea.current_name);
//             }
//         });
//     });
// }
//
// function getOldPrefAndCities() {
//     axios.post('/api/prefs', {
//         lang: $('html').attr('lang'),
//     }).then(function (response) {
//         var prefs = response.data.data;
//
//         $('#pref').find('option').remove();
//
//         for (var index in prefs) {
//             var pref = prefs[index];
//             var prefOption = '';
//
//             if (pref.id === $('#pref').data('oldData')) {
//                 prefOption += '<option value="' + pref.id + '" selected>';
//             } else {
//                 prefOption += '<option value="' + pref.id + '">';
//             }
//
//             prefOption += pref.current_name;
//             prefOption += '</option>';
//
//             $('#pref').append(prefOption);
//         }
//
//         axios.post('/api/cities', {
//             lang: $('html').attr('lang'),
//             pref: $('#pref').data('oldData'),
//         }).then(function (response) {
//             var cities = response.data.data;
//
//             $('#city').find('option').remove();
//
//             for (var index in cities) {
//                 var city = cities[index];
//                 var cityOption = '';
//
//                 if (city.id === $('#city').data('oldData')) {
//                     cityOption += '<option value="' + city.id + '" selected>';
//                 } else {
//                     cityOption += '<option value="' + city.id + '">';
//                 }
//
//                 cityOption += city.current_name;
//                 cityOption += '</option>';
//
//                 $('#city').append(cityOption);
//             }
//         });
//     });
// }

import './_dialog';
import './_api';

var currentName = $('html').attr('lang') + '_name';

$(function () {
    if (!!$(`body #postCode`).val()) {
        getCityArea();
    } else {
        if (!!$(`body #pref`).data('oldData')) {
            getOldCityArea();
        }
    }

    $(`body #searchCityArea`).on('click', function () {
        getCityArea();
    });

    $('body #pref').on('change', function () {
        var pref = $(this).val();

        fetchData(`
            {
                cities(pref_id: ${pref}) {
                    id
                    pref_id
                    ${currentName}
                }
            }
        `).then(function (response) {
            getCityOptions(response.cities);

            $(`body #postCode`).val('');

            $(`body #address`).val('');
        });
    });

    $(`body .btn--form`).on('click', function () {
        $(this).prop('disabled', true);

        $(`body #myForm`).submit();
    });
});

function getCityArea() {
    var postCode = $(`body #postCode`).val();

    fetchData(`
        {
            cityArea(post_code: "${postCode}") {
                id
                city_id
                ${currentName}
                city {
                    id
                    pref_id
                    ${currentName}
                    pref {
                        id
                        area_id
                        ${currentName}
                    }
                }
            }
        }
    `).then(function (response) {
        var cityArea = response.cityArea;

        cityArea.current_name = response.cityArea[currentName];

        selectPref(cityArea.city.pref_id);

        fetchData(`
            {
                cities(pref_id: ${cityArea.city.pref_id}) {
                    id
                    pref_id
                    ${currentName}
                }
            }
        `).then(function (response) {
            getCityOptions(response.cities);

            $(`body #city option[value="${cityArea.city_id}"]`).prop('selected', true).attr('selected', 'selected');

            $(`body #address`).val(cityArea.current_name);
        });
    });
}

function getOldCityArea() {
    var oldPrefData = $(`body #pref`).data('oldData');
    var oldCityData = $(`body #city`).data('oldData');

    selectPref(oldPrefData);

    fetchData(`
        {
            cities(pref_id: ${oldPrefData}) {
                id
                pref_id
                ${currentName}
            }
        }
    `).then(function (response) {
        getCityOptions(response.cities);

        $(`body #city option[value="${oldCityData}"]`).prop('selected', true).attr('selected', 'selected');
    });
}

function getCityOptions(cities = []) {
    $(`body #city option:gt(0)`).remove();

    $.each(cities, function (index, city) {
        $(`body #city`).append(`
            <option value="${city.id}">
                ${city[currentName]}
            </option>
        `);
    });
}

function selectPref(selectedPref = null) {
    $('body #pref')
        .find('option:selected')
        .prop('selected', false)
        .removeAttr('selected')
        .closest(`#pref`)
        .find(`option[value="${selectedPref}"]`)
        .prop('selected', true)
        .attr('selected', 'selected');
}
